<template>
    <v-dialog v-model="isDialogOpen" width="1000">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>
                    <span class="font-weight-bold">{{ headerTitle }}</span>
                </v-toolbar-title>
                <v-toolbar-items class="pr-2 ml-auto">
                    <v-btn icon @click.native="$emit('close')">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container>
                <category-form :initial-category="initialCategory" :mode="dialogType" @submitted="onSubmitted"
                    @failed="onFailed"></category-form>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import { CategoryForm } from '../../components/forms'
import { MixinDialogRemote } from '../../mixins'

export default {
    name: "CategoryDialog",
    mixins: [MixinDialogRemote],
    components: {
        CategoryForm
    },
    props: ['dialogType', 'initialCategory'],
    data() {
        return {}
    },
    computed: {
        headerTitle() {
            return this.dialogType === 'add' ? this.$t('addCategory') : this.$t('editCategory');
        }
    },
    methods: {
        onSubmitted(data) {
            const actionType = this.dialogType === 'add' ? 'categoryAdd' : 'categoryUpdate';

            this.$emit('submitted', { type: actionType, data });
        },
        onFailed(error) {
            const actionType = this.dialogType === 'add' ? 'categoryAdd' : 'categoryUpdate';
            this.$emit('failed', { type: actionType, data: error });
        }
    }
}
</script>

<style scoped></style>
